var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsermanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.71,
    height: 17.604,
    viewBox: "0 0 20.71 17.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -29.114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.219,37.723c1.957,0,3.544-1.927,3.544-4.3s-.521-4.3-3.544-4.3-3.544,1.927-3.544,4.3S129.262,37.723,131.219,37.723Z",
    transform: "translate(-120.864 0)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.011,202.765c-.066-4.142-.606-5.322-4.745-6.069a2.908,2.908,0,0,1-3.881,0c-4.094.739-4.668,1.9-4.743,5.934-.006.329-.009.347-.01.308,0,.072,0,.2,0,.435,0,0,.985,1.986,6.693,1.986s6.694-1.986,6.694-1.986c0-.148,0-.252,0-.322A2.577,2.577,0,0,1,82.011,202.765Z",
    transform: "translate(-64.97 -158.642)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.007,52.01c1.59,0,2.878-1.565,2.878-3.5s-.423-3.5-2.878-3.5a4.1,4.1,0,0,0-1.074.127,7.056,7.056,0,0,1,.645,3.329,5.9,5.9,0,0,1-.884,3.151A2.466,2.466,0,0,0,263.007,52.01Z",
    transform: "translate(-247.734 -15.056)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.376,186.054c-.053-3.364-.493-4.322-3.854-4.929a2.015,2.015,0,0,1-1.576.6c-.046,0-.09,0-.133,0a4.422,4.422,0,0,1,1.808,1.4c.812,1.113,1,2.608,1.037,4.8,2.262-.447,2.725-1.38,2.725-1.38,0-.122,0-.205,0-.262A1.954,1.954,0,0,1,289.376,186.054Z",
    transform: "translate(-268.672 -143.902)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.833,52.011a2.467,2.467,0,0,0,1.313-.385,5.9,5.9,0,0,1-.884-3.151,7.057,7.057,0,0,1,.645-3.329,4.1,4.1,0,0,0-1.074-.127c-2.455,0-2.878,1.565-2.878,3.5S49.244,52.011,50.833,52.011Z",
    transform: "translate(-45.397 -15.057)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57,181.724c-.043,0-.088,0-.133,0a2.015,2.015,0,0,1-1.576-.6c-3.362.607-3.8,1.565-3.854,4.929a2.041,2.041,0,0,1-.006.232c0,.057,0,.14,0,.262,0,0,.464.933,2.725,1.38.039-2.2.225-3.691,1.037-4.8A4.422,4.422,0,0,1,5.57,181.724Z",
    transform: "translate(0 -143.901)",
    fill: "#697384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermanagement);
export default __webpack_public_path__ + "static/media/usermanagement.cf0741a8b4f2f15a91428b0ff159dda0.svg";
export { ForwardRef as ReactComponent };